import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * 团队空间状态（V0.1 团队协作）
 *
 * 机制：空间切换 = 后端换发 token（POST /auth/token/exchange），数据隔离由后端按
 * token 身份天然实现。本 slice 仅记录「当前停留在哪个空间」用于 UI 展示与显隐规则，
 * current 为 null 即个人空间（默认态，未切换过 / 已回落）。
 */

/** 团队角色（后端契约 team_role：1-拥有者 2-成员） */
export enum TeamRole {
  Owner = 1,
  Member = 2,
}

/** 团队空间信息 */
export interface TeamSpaceInfo {
  /** 团队账户 user_id（即 token/exchange 的 target_user_id） */
  teamId: string;
  teamName: string;
  role: TeamRole;
}

export interface SpaceState {
  /** 当前空间；null = 个人空间 */
  current: TeamSpaceInfo | null;
  /** 个人账号 user_id（/user/profile 返回的 personal_user_id，画布 creator_user_id 比对用） */
  personalUserId: string | null;
  /** 最近一次切换时间（排查用） */
  updatedAt: number;
}

const initialState: SpaceState = {
  current: null,
  personalUserId: null,
  updatedAt: 0,
};

const spaceSlice = createSlice({
  name: 'space',
  initialState,
  reducers: {
    /** 切换空间：team 传完整信息，personal 传 null */
    setCurrentSpace: (state, action: PayloadAction<TeamSpaceInfo | null>) => {
      state.current = action.payload;
      state.updatedAt = Date.now();
    },
    /** 记录个人账号 user_id（登录 / profile 拉取后写入） */
    setPersonalUserId: (state, action: PayloadAction<string | null>) => {
      state.personalUserId = action.payload;
    },
    /** 退出登录时重置（配合 clearAllUserData） */
    resetSpace: () => initialState,
  },
});

export const { setCurrentSpace, setPersonalUserId, resetSpace } = spaceSlice.actions;

export default spaceSlice.reducer;
